import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { SlimScrollOptions, Incident } from "app/shared/shared.module";
import { Location } from "app/common/location";

import { Subscription } from "rxjs/Subscription";
import { PersonService } from "app/person/person.service";

@Component({
	selector: 'app-archived-cases',
	templateUrl: './archived-cases.component.html',
	styleUrls: ['./archived-cases.component.css']
})
export class ArchivedCasesComponent implements OnInit {

    PersonId: any;
	CaseListings: Incident[];
    SlimScrollOptions = SlimScrollOptions;
    sub: Subscription;
    GetPersonDetailsSubscription: Subscription;

    constructor(private personService: PersonService, private route: ActivatedRoute) { }

    ngOnInit() {
        this.sub = this.route.parent.params.subscribe(params => {
            if (params && params['id']) {
                this.PersonId = params['id'];
                this.GetIncidents();
            }
        })
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
        if (this.GetPersonDetailsSubscription != null) {
            this.GetPersonDetailsSubscription.unsubscribe();
        }
    }

    GetIncidents() {
        this.GetPersonDetailsSubscription = this.personService.GetPersonDetails(this.PersonId).subscribe(
            person => {
                this.CaseListings = person.Incidents;
            }, err => {
                console.log(err);
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/person/details/archived-cases/archived-cases.component.ts